const translations = {
  fr: {
    title: "Explorez Notre Catalogue Formation",
    description: "Trouvez facilement les cours, modules et parcours adaptés à vos ambitions professionnelles.",
    login: "Se Connecter",
    language: "Français",
  },
  en: {
    title: "Explore Our Training Catalog",
    description: "Easily find courses, modules, and paths suited to your career goals.",
    login: "Login",
    language: "English",
  },
};

export default translations;
